"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract_ValuedItem = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Money_1 = require("./RTTI_Money");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
exports.RTTI_Contract_ValuedItem = t.recursion('IContract_ValuedItem', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        entityCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        entityReference: RTTI_Reference_1.RTTI_Reference,
        identifier: RTTI_Identifier_1.RTTI_Identifier,
        effectiveTime: RTTI_dateTime_1.RTTI_dateTime,
        _effectiveTime: RTTI_Element_1.RTTI_Element,
        quantity: RTTI_Quantity_1.RTTI_Quantity,
        unitPrice: RTTI_Money_1.RTTI_Money,
        factor: RTTI_decimal_1.RTTI_decimal,
        _factor: RTTI_Element_1.RTTI_Element,
        points: RTTI_decimal_1.RTTI_decimal,
        _points: RTTI_Element_1.RTTI_Element,
        net: RTTI_Money_1.RTTI_Money,
        payment: t.string,
        _payment: RTTI_Element_1.RTTI_Element,
        paymentDate: RTTI_dateTime_1.RTTI_dateTime,
        _paymentDate: RTTI_Element_1.RTTI_Element,
        responsible: RTTI_Reference_1.RTTI_Reference,
        recipient: RTTI_Reference_1.RTTI_Reference,
        linkId: t.array(t.string),
        _linkId: t.array(RTTI_Element_1.RTTI_Element),
        securityLabelNumber: t.array(RTTI_unsignedInt_1.RTTI_unsignedInt),
        _securityLabelNumber: t.array(RTTI_Element_1.RTTI_Element)
    });
});
//# sourceMappingURL=RTTI_Contract_ValuedItem.js.map